export default "__VITE_ASSET__BDnWZNAA__"